import React from "react";
import { Send } from "lucide-react";
import { ApplyModal } from "./ApplyModal";

function HeroContactModal({ lang }) {
  const [show, setShow] = React.useState(false);
  const label = lang === "az" ? "Müraciət et" : lang === "ru" ? "Подать заявку" : "Apply Now";
  return (
    <>
      <button
        onClick={() => setShow(true)}
        className="w-full sm:w-auto inline-flex items-center justify-center bg-white/10 backdrop-blur text-white border border-white/30 px-8 py-4 rounded-full font-semibold text-base md:text-lg hover:bg-white/20 transition-all duration-300"
      >
        <Send className="mr-2 w-5 h-5" />{label}
      </button>
      <ApplyModal show={show} onClose={() => setShow(false)} lang={lang} accentColor="#1e3a8a" courseTitle={null} />
    </>
  );
}


export { HeroContactModal };
